import type { SVGProps } from 'react';
const SvgReport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Report_svg__a)">
      <path
        d="M4.5 6h7m-7 4h5m5.033 4.067A.933.933 0 0 1 13.6 15H2.4a.933.933 0 0 1-.933-.933V1.933A.933.933 0 0 1 2.4 1h9.361c.244 0 .478.095.652.265l1.838 1.794a.94.94 0 0 1 .282.668z"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Report_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReport;
